export default function ContactFooter() {
  return (
    <footer
      className="w-full bg-foreground-900 py-24 px-6 md:px-10 lg:px-16 relative overflow-hidden"
      aria-label="Contact information"
    >
      <div className="absolute inset-0 select-none pointer-events-none flex items-end justify-start px-8 md:px-16 overflow-hidden opacity-[0.04]">
        <span className="font-heading text-[12rem] md:text-[18rem] font-bold text-background-50 leading-none translate-y-16">
          EXCELLENCE
        </span>
      </div>

      <div className="max-w-[1200px] mx-auto relative z-10">
        <h2 className="font-heading text-[2.5rem] md:text-[3rem] font-semibold text-background-50 mb-20 tracking-tight">
          Get in touch
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <p className="font-body text-sm text-foreground-400 leading-relaxed max-w-[14rem]">
              For inquiries and collaboration opportunities, reach out through any of the channels below.
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm font-medium text-background-50 mb-5 uppercase tracking-wide">
              Address
            </h3>
            <address className="not-italic">
              <p className="font-body text-sm text-foreground-300 leading-[1.8]">
                Solangsvagen 31
              </p>
              <p className="font-body text-sm text-foreground-300 leading-[1.8]">
                192 54
              </p>
              <p className="font-body text-sm text-foreground-300 leading-[1.8]">
                Sollentuna
              </p>
              <p className="font-body text-sm text-foreground-300 leading-[1.8]">
                Sweden
              </p>
            </address>
          </div>

          <div>
            <h3 className="font-label text-sm font-medium text-background-50 mb-5 uppercase tracking-wide">
              Contact
            </h3>
            <p className="font-body text-sm text-foreground-300 leading-[1.8]">
              +46 790977038
            </p>
            <p className="font-body text-sm text-foreground-300 leading-[1.8]">
              co@shilanzait.com
            </p>
          </div>

          <div>
            <p className="font-body text-xs text-foreground-500 leading-relaxed mt-14 lg:mt-0">
              We welcome inquiries about engineering collaboration and technical partnership opportunities.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}